import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import { when } from "util/support";
import Tabs from "ui/atoms/Tabs";
import { FormField, type OnboardingDirectorsAndShareholdersProps } from "../types";
import Shareholder from "./Shareholder";
import useOtherShareholders from "./useOtherShareholders";

const OtherShareholders = (onboardingDirectorsAndShareholdersProps: OnboardingDirectorsAndShareholdersProps) => {
    const { values, isIncomplete } = onboardingDirectorsAndShareholdersProps;

    const {
        tab,
        addShareholder,
        deleteShareholder,
        onChangeTab,
        canAddShareholder
    } = useOtherShareholders(onboardingDirectorsAndShareholdersProps);

    return (
        <Box
            sx={{
                maxWidth: 432
            }}
        >
            <Tooltip
                arrow
                placement='top'
                title={when(
                    !canAddShareholder() && isIncomplete,
                    'Please fill out all required fields before adding another shareholder.'
                )}
            >
                <Button
                    sx={{
                        pointerEvents: 'all !important'
                    }}
                    startIcon={(
                        <AddIcon />
                    )}
                    onClick={addShareholder}
                    variant='soft'
                    disabled={!canAddShareholder()}
                >
                    Add Other Shareholder
                </Button>
            </Tooltip>
            <Tabs
                value={tab}
                onChange={onChangeTab}
                TabPanelProps={{
                    sx: {
                        px: 0
                    }
                }}
                model={values[FormField.OtherPeople.FieldPrefix]
                    .map((identity, key) => ({
                        key,
                        label: (
                            <Button
                                endIcon={Boolean(isIncomplete) && (
                                    <Tooltip
                                        arrow
                                        placement='top'
                                        title='Delete Shareholder'
                                    >
                                        <IconButton
                                            color='error'
                                            size='small'
                                            onClick={() => deleteShareholder(key)}
                                        >
                                            <DeleteForeverIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            >
                                {identity.name || `Shareholder ${key + 1}`}
                            </Button>
                        ),
                        component: (
                            <Shareholder
                                {...onboardingDirectorsAndShareholdersProps}
                                index={key}
                            />
                        )
                    }))}
            />
        </Box>
    );
};

export default OtherShareholders;
